import React, { useState, useEffect } from "react";
import { DatePicker, Input } from "antd";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { ApiURL } from "../../../../services/apiConstants";
import { post } from "../../../../services/services";
import moment from "moment";

const BasicEngineLog = () => {
  const { eng_log_basic_id } = useParams();
  const [sea_water_temp, set_sea_water_temp] = useState("");
  const [ambient_temp, set_ambient_temp] = useState("");
  const [engine_room_temp, set_engine_room_temp] = useState("");
  const [engine_room_barometric_press, set_engine_room_barometric_press] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [logDate, set_LogDate] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));

  const VIEW_BASIC_DETAILS_LOGBOOK_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      post(ApiURL.view_eng_log_basic_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const Logbook = res?.eng_log_data;
          set_sea_water_temp(Logbook?.sea_water_temp);
          set_ambient_temp(Logbook?.ambient_temp);
          set_engine_room_temp(Logbook?.engine_room_temp);
          set_engine_room_barometric_press(Logbook?.engine_room_barometric_press);
          set_Free_Text(Logbook?.basic_comment);
          set_LogDate(Logbook?.date_time_log);
        }
      });
    } catch (error) {
      console.error("Error View logbook:", error);
    }
  };

  useEffect(() => {
    VIEW_BASIC_DETAILS_LOGBOOK_API();
  }, []);

  return (
    <>
      <div className="white-container">
        <div className="theme-content-left-head">
          <h2> Basic Information </h2>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                showTime
                disabled
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>

       

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Sea water Temp (°C)</label>
              <Input
                disabled
                value={sea_water_temp}
                placeholder="Sea water temp (°C)"
                onChange={(e) => set_sea_water_temp(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Ambient Temp (°C)</label>
              <Input
                disabled
                value={ambient_temp}
                placeholder="ambient temp (°C)"
                onChange={(e) => {
                  set_ambient_temp(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Engine Room Temp (°C)</label>
              <Input
                disabled
                value={engine_room_temp}
                placeholder="Engine room temp (°C)"
                onChange={(e) => set_engine_room_temp(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Engine Room Barometric Pressure (Bar)</label>
              <Input
                disabled
                value={engine_room_barometric_press}
                placeholder="engine room barometric press (Bar)"
                onChange={(e) => {
                  set_engine_room_barometric_press(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

       
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Basic Engine Comments</label>
              <TextArea
                disabled
                rows={6}
                placeholder="Basic Engine Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicEngineLog;
